import React from 'react';
import Link from 'components/commercetools-ui/atoms/link';
import { useFormat } from 'helpers/hooks/useFormat';
import StarIcon from '../star';

export interface RatingProps {
  rating: number;
  reviewCount: number;
  reviewsLink?: string;
  starSize?: number;
  className?: string;
  textSize?: 'default' | 'large';
}

export const Rating: React.FC<RatingProps> = ({
  rating,
  reviewCount,
  reviewsLink,
  starSize = 24,
  className = '',
  textSize = 'default',
}) => {
  const { formatMessage } = useFormat({ name: 'common' });
  const safeRating = Math.max(0, Math.min(rating, 5)).toFixed(1);

  const reviewLabel =
    reviewCount === 1
      ? formatMessage({ id: 'review.singular', defaultMessage: 'Review' })
      : formatMessage({ id: 'review.plural', defaultMessage: 'Reviews' });

  const reviewText = `(${reviewCount} ${reviewLabel})`;

  const ratingValueClass = textSize === 'large' ? 'body-text-large' : 'body-text-x-large';

  return (
    <div className={`flex items-center gap-4 ${className}`}>
      <StarIcon variant="filled" size={starSize} />

      <p className={`font-bold ${ratingValueClass}`}>{safeRating}</p>

      {reviewsLink ? (
        <Link link={reviewsLink} variant="primary" className="hyperlink ml-4 whitespace-nowrap text-14">
          {reviewText}
        </Link>
      ) : (
        <p className="body-text-small whitespace-nowrap text-tertiary">{reviewText}</p>
      )}
    </div>
  );
};

export default Rating;
